import React, { useState, useContext } from 'react'

import { Modal, DatePicker, Checkbox } from 'antd'
import { connect, useSelector } from 'react-redux'

import { SchoolContext } from '../../Providers/SchoolProvider'
import { selectUser } from '../../reducers/UserReducer'
import { faUserGraduate } from '@fortawesome/pro-solid-svg-icons'
import { onError } from '../../utils/apiHelper'
import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'
import IconLabel from '../icons/IconLabel'
import { getDocument } from '../../utils/api/export'
import { exportStudentsHours } from '../../utils/api/internship'
import { isNonEmptyArray } from '../../utils'

const ModalHours = ({ visible, onClose }) => {
  const { useWeightedHours, schoolSections } = useContext(SchoolContext)

  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [selectedSchoolSections, setSelectedSchoolSections] = useState([])

  const isAllChecked = selectedSchoolSections.length === schoolSections.length

  const handleSubmit = () => {
    exportStudentsHours(
      user,
      { startDate, endDate, filters: { studentActiveSections: selectedSchoolSections }, language: user.language.toLowerCase(), useWeightedHours }
    ).then(({ job }) => getDocument(
      job,
      user,
      () => onError(t('spreadsheet_download.error'))
    )).catch(error => {
      console.error(error.message)
      onError(t('internships_export.error'))
    })
  }

  const handleCheckAll = () => {
    if (isAllChecked) {
      setSelectedSchoolSections([])
    } else {
      setSelectedSchoolSections(schoolSections.map(ss => ss.id))
    }
  }

  return (
    <Modal
      width={520}
      className='form-modal-with-footer'
      title={t('school.option.export_hours')}
      visible={visible}
      cancelText={t('modal.cancel_button')}
      onCancel={onClose}
      onOk={handleSubmit}
      okText={t('common.export')}
      okButtonProps={{ disabled: !startDate || !endDate || startDate > endDate }}
      destroyOnClose
    >
      <div className='flex-row jc-around'>
        <DatePicker
          className='pd-8'
          placeholder={t('Start date')}
          onChange={setStartDate}
          value={startDate}
        />
        <DatePicker
          placeholder={t('End date')}
          onChange={setEndDate}
          value={endDate}
        />
      </div>
      <h4 className='mt-12 mb-12'><b><IconLabel icon={faUserGraduate} text={t('students_to_select')} /></b></h4>
      <div className='pd-12'>
        {isNonEmptyArray(schoolSections) && (
          <Checkbox
            checked={isAllChecked}
            style={{ marginBottom: 10 }}
            onChange={handleCheckAll}
          >
            {t('common.select_all')}
          </Checkbox>
        )}
        <Checkbox.Group
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '10px 16px'
          }}
          value={selectedSchoolSections}
          onChange={setSelectedSchoolSections}
        >
          {schoolSections.map(ss => (
            <Checkbox
              value={ss.id}
              key={ss.id}
              style={{ margin: 0 }}
            >
              {`${ss.sectionToYear.sectionAbbreviation} (${ss.sectionToYear.schoolYearName})`}
            </Checkbox>
          ))}
        </Checkbox.Group>

      </div>
    </Modal>

  )
}

export default connect()(ModalHours)
